'use es6';

import tinymce from 'tinymce';

// Delay setting the legacy `force_p_newlines` so that paragraphs are created
// on carriage return. We wait until init because v5 of tinymce core checks for
// `force_p_newlines` during init to register an `addRootBlocks()` callback to
// the `NodeChange` event, which should only be the case if we explicitly set
// `forced_root_block: true`. See https://git.hubteam.com/HubSpot/rich-text-lib/issues/1527.
function initForcePNewlinePlugin(editor) {
  if (tinymce.majorVersion === '5' && editor.getParam('legacy_force_p_newlines')) {
    editor.on('init', () => {
      editor.settings.force_p_newlines = true;
    });
  }
}
export default initForcePNewlinePlugin;